/* VitaFresh Warenkorb (Präfix vfwk-): Empfehlungen «Hast Du etwas vergessen?» (Warenkorbseite) und
   «Könnte Dir auch schmecken» (Mini-Warenkorb), Extras-Fenster, «Warenkorb leeren» in zwei Schritten.
   Entscheidungen stehen DOM-frei in assets/vf-warenkorb-logik.js (window.VFWK), Tests: tests/vf-warenkorb.test.js.
   Daten: /cart.js, /collections/warenkorb-empfehlungen/products.json (von Hand sortiert, Pasci 21.10.2026), zum Auffüllen
   bzw. als Rückfall /collections/alle-hauptgerichte/products.json (Bestseller) und /collections/addon/products.json
   (nur Produkte mit Tag «addon»). Preise kommen aus dem Shop, es wird nichts erfunden.
   Profil (Pasci 22.10.2026): Tags der Gerichte im Warenkorb aus den geladenen Kollektionen oder sessionStorage «vfwk-tags»; fehlt ein
   Gericht dort, /products/<handle>.js (je Warenkorb-Stand höchstens TAGS_MAX, Abbruch nach TAGS_MS). Die Entscheidung trifft
   VFWK.gerichtVorschlaege (harte Regeln, Abwechslung).
   Nach jeder Änderung: window.refreshCart() (Theme-Schnittstelle, assets/component-cart.js: zeichnet Mini-Warenkorb bzw. Seite
   neu und meldet «cart-updated» auf <cart-form>); danach lädt sich der Bereich selbst neu. */
(function (root) {
  "use strict";

  /* /cart.js über die Warenkorb-Basis (ein Abruf je Meldung für alle Skripte, assets/vf-warenkorb-basis.js), sonst direkt */
  function korbHolen() {
    if (root.VFWarenkorbBasis) return root.VFWarenkorbBasis.holen();
    return root.fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { if (!r.ok) throw new Error("cart.js " + r.status); return r.json(); });
  }
  var L = root.VFWK;
  var doc = root.document;
  if (!L || !doc) return;
  if (root.VFWK_DOM) return; /* doppelt eingebunden */
  root.VFWK_DOM = true;

  /* Vorschläge aus der Kollektion «Warenkorb-Empfehlungen» (Admin, manuell sortiert: die Reihenfolge ist der Vorrang). Fehlt sie oder ist sie
     leer, oder liegen fast alle schon im Warenkorb: Bestseller von «Alle Hauptgerichte» (die 250 meistverkauften; die Kollektion hat 441). */
  var EMPF_URL = "/collections/warenkorb-empfehlungen/products.json?limit=50";
  var GERICHTE_URL = "/collections/alle-hauptgerichte/products.json?limit=250&sort_by=best-selling";
  var KUEHLTASCHE = "kuhltasche-1";
  var EXTRAS_URL = "/collections/addon/products.json?limit=250";
  var pools = null, poolLauf = null;
  var tagMap = {}, tagLaeuft = {}, TAGS_MAX = 12, TAGS_MS = 3000, TAGS_SPEICHER = "vfwk-tags"; /* handle -> Tags (Profil) */
  /* Tags vom letzten Seitenaufbau (sessionStorage): kein zweiter Abruf je Gericht in derselben Sitzung. Fehlt der Speicher (privates
     Fenster, gesperrt): wie ohne, es wird nur neu geholt. */
  try {
    var gemerkt = JSON.parse(root.sessionStorage.getItem(TAGS_SPEICHER) || "{}");
    if (gemerkt && typeof gemerkt === "object") Object.keys(gemerkt).forEach(function (h) { if (Array.isArray(gemerkt[h])) tagMap[h] = gemerkt[h]; });
  } catch (e) { tagMap = {}; }
  var stand = 0, planTimer = null, laeuft = false, nochmal = false;
  var cartLetzter = null;
  var popup = null, popupFokus = null;
  var skript = doc.querySelector("script[data-vfwk-b2b]");
  var b2b = !!(skript && skript.getAttribute("data-vfwk-b2b") === "true"); /* Konto mit Tag no_loyalty */
  /* cart.item_count beim Seitenaufbau (fehlt: wie bisher laden). Solange der Warenkorb leer ist und sich nichts gemeldet hat, gibt es nichts
     zu holen: kein /cart.js beim Laden und nicht, wenn der (leere) Bereich ins Bild kommt. Jede Meldung (cart-updated, Kopfzähler, Tab zurück) hebt das auf. */
  var leerBekannt = !!(skript && parseInt(skript.getAttribute("data-vfwk-anzahl"), 10) === 0);

  function holeJson(url) {
    return root.fetch(url, { headers: { Accept: "application/json" } }).then(function (r) {
      if (!r.ok) throw new Error(url + " " + r.status);
      return r.json();
    });
  }

  function ladePools() {
    if (pools) return Promise.resolve(pools);
    if (poolLauf) return poolLauf;
    /* Gerichte und Extras getrennt laden: fehlen die Extras, bleiben die Gerichte; fehlen die Gerichte, bleibt der Bereich leer.
       Zuerst die kleine Kollektion; nur wenn sie fehlt oder leer ist, die Bestseller (grosse Antwort). */
    var gl = holeJson(EMPF_URL).then(function (j) { return L.ausProdukten(j); }).catch(function () { return null; })
      .then(function (kur) {
        if (kur && kur.length) return { liste: kur, kuratiert: true };
        return ladeBestseller().then(function (b) { return b ? { liste: b, kuratiert: false } : null; });
      });
    var ex = holeJson(EXTRAS_URL).then(function (j) { return L.ausProdukten(j, "addon"); }).catch(function () { return []; });
    poolLauf = Promise.all([gl, ex]).then(function (r) {
      if (!r[0]) { poolLauf = null; return null; }
      r[1].forEach(function (p) { p.groesse = L.extraGroesse(p); });
      var handles = null, ohne = {};
      ohne[KUEHLTASCHE] = true;
      r[1].forEach(function (p) { ohne[p.handle] = true; });
      /* Bestseller-Vorrat: nur Gerichte dieser Kollektion zählen für die Grösse (wie bisher). Kleine Kollektion: alles ausser Extras und Kühltasche. */
      if (!r[0].kuratiert) { handles = {}; r[0].liste.forEach(function (p) { handles[p.handle] = true; }); }
      pools = { gerichte: r[0].liste, extras: r[1], handles: handles, ohne: ohne, kuratiert: r[0].kuratiert, ersatz: null };
      tagsMerken(r[0].liste); tagsMerken(r[1]);
      return pools;
    });
    return poolLauf;
  }
  var bestLauf = null;
  function ladeBestseller() {
    if (!bestLauf) bestLauf = holeJson(GERICHTE_URL).then(function (j) { var l = L.ausProdukten(j); return l.length ? l : null; })
      .catch(function () { bestLauf = null; return null; });
    return bestLauf;
  }
  /* Kleine Kollektion, aber fast alles davon liegt schon im Warenkorb: einmal die Bestseller zum Auffüllen holen (scheitert das, bleibt es
     bei weniger Karten). */
  function mitErsatz(cart) {
    if (!pools || !pools.kuratiert || pools.ersatz || !L.brauchtErsatz(pools.gerichte, cart, 4, tagMap)) return Promise.resolve();
    return ladeBestseller().then(function (b) { if (b && pools) { pools.ersatz = b; tagsMerken(b); } });
  }
  function poolOpt() { return { b2b: b2b, ersatz: pools && pools.ersatz, ohne: pools && pools.ohne, tags: tagMap }; }

  /* Tags aus einer geladenen Kollektion merken (ein Abruf je Gericht bleibt gespart). */
  function tagsMerken(liste) {
    (liste || []).forEach(function (p) { if (p && p.handle) tagMap[p.handle] = p.tags || []; });
  }
  /* Nur Tags der Gerichte im Warenkorb merken (klein), nicht ganze Kollektionen. */
  function tagsSpeichern(cart) {
    var m = {};
    ((cart && cart.items) || []).forEach(function (i) { if (i && tagMap[i.handle] && !(pools && pools.ohne[i.handle])) m[i.handle] = tagMap[i.handle]; });
    try { root.sessionStorage.setItem(TAGS_SPEICHER, JSON.stringify(m)); } catch (e) { /* ohne Speicher */ }
  }
  /* Tags der Gerichte im Warenkorb, die in keiner geladenen Kollektion und nicht im Speicher stehen: /products/<handle>.js, höchstens
     TAGS_MAX je Warenkorb-Stand, jeder Abruf nach TAGS_MS abgebrochen (die Karten warten nie länger). Kühltasche, Extras und
     Geschenkkarten (ohne Versand) nie. Scheitert ein Abruf, zählt das Gericht diesmal nicht fürs Profil; beim nächsten Stand neuer Versuch. */
  function tagsHolen(cart) {
    if (!pools) return Promise.resolve();
    var offen = [];
    ((cart && cart.items) || []).forEach(function (i) {
      var h = i && i.handle;
      if (!h || tagMap[h] || pools.ohne[h] || i.requires_shipping === false || offen.indexOf(h) >= 0) return;
      offen.push(h);
    });
    return Promise.all(offen.slice(0, TAGS_MAX).map(function (h) {
      if (!tagLaeuft[h]) {
        var ctrl = typeof root.AbortController === "function" ? new root.AbortController() : null;
        var uhr = ctrl ? root.setTimeout(function () { ctrl.abort(); }, TAGS_MS) : 0;
        tagLaeuft[h] = root.fetch("/products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { if (!r.ok) throw new Error(h + " " + r.status); return r.json(); })
          .then(function (j) { if (j && Array.isArray(j.tags)) tagMap[h] = j.tags; })
          .catch(function () { /* ohne Tags: zählt diesmal nicht fürs Profil */ })
          .then(function () { root.clearTimeout(uhr); delete tagLaeuft[h]; });
      }
      return tagLaeuft[h];
    })).then(function () { tagsSpeichern(cart); });
  }

  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function svgPlus() {
    var s = doc.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", "0 0 24 24"); s.setAttribute("aria-hidden", "true"); s.setAttribute("focusable", "false");
    var p = doc.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", "M12 5v14M5 12h14"); p.setAttribute("fill", "none"); p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "2.6"); p.setAttribute("stroke-linecap", "round");
    s.appendChild(p);
    return s;
  }
  function svgPfeil() {
    var s = doc.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", "0 0 24 24"); s.setAttribute("aria-hidden", "true"); s.setAttribute("focusable", "false");
    var p = doc.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", "M9 6l6 6-6 6"); p.setAttribute("fill", "none"); p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "2.4"); p.setAttribute("stroke-linecap", "round"); p.setAttribute("stroke-linejoin", "round");
    s.appendChild(p);
    return s;
  }
  function svgKreuz() {
    var s = doc.createElementNS("http://www.w3.org/2000/svg", "svg");
    s.setAttribute("viewBox", "0 0 24 24"); s.setAttribute("aria-hidden", "true"); s.setAttribute("focusable", "false");
    var p = doc.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", "M6 6l12 12M18 6L6 18"); p.setAttribute("fill", "none"); p.setAttribute("stroke", "currentColor");
    p.setAttribute("stroke-width", "2.4"); p.setAttribute("stroke-linecap", "round");
    s.appendChild(p);
    return s;
  }

  function bildUrl(src, breite) {
    if (!src) return "";
    return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + breite;
  }

  function bildKnoten(src, cls, breite) {
    var img = el("img", cls);
    img.alt = ""; img.loading = "lazy"; img.decoding = "async";
    if (src) img.src = bildUrl(src, breite || 96);
    return img;
  }

  /* ---- Karte ---- */
  function plusKnopf(k) {
    var b = el("button", "vfwk-k__plus");
    b.type = "button";
    b.setAttribute("aria-label", k.title + " hinzufügen");
    b.setAttribute("data-vfwk-add", String(k.variante));
    b.setAttribute("data-vfwk-name", k.title); /* für die Ansage «… hinzugefügt» */
    b.appendChild(svgPlus());
    return b;
  }

  function karteGericht(k) {
    var d = el("div", "vfwk-k");
    d.appendChild(bildKnoten(k.bild, "vfwk-k__bild", 96));
    d.appendChild(el("p", "vfwk-k__name", k.title));
    var gr = el("p", "vfwk-k__gr");
    var s = el("span", null, (k.groesse ? k.groesse + " · " : ""));
    s.appendChild(el("b", null, L.geldText(k.preis)));
    gr.appendChild(s);
    if (k.marke) gr.appendChild(el("span", "vfwk-k__marke", k.marke));
    d.appendChild(gr);
    d.appendChild(plusKnopf(k));
    return d;
  }

  function karteExtras() {
    var b = el("button", "vfwk-k vfwk-k--extras");
    b.type = "button";
    b.setAttribute("data-vfwk-popup", "");
    b.setAttribute("aria-label", "Alle Extras anzeigen");
    var coll = el("span", "vfwk-k__bild vfwk-k__collage");
    coll.setAttribute("aria-hidden", "true");
    ((pools && pools.extras) || []).slice(0, 4).forEach(function (p) { coll.appendChild(bildKnoten(p.bild, null, 64)); });
    b.appendChild(coll);
    b.appendChild(el("p", "vfwk-k__name", "Extras"));
    var gr = el("p", "vfwk-k__gr");
    gr.appendChild(el("span", null, "Shots, Noshballs, Saucen · "));
    gr.appendChild(el("b", null, "Alle anzeigen"));
    b.appendChild(gr);
    var pf = el("span", "vfwk-k__plus vfwk-k__plus--pfeil");
    pf.setAttribute("aria-hidden", "true");
    pf.appendChild(svgPfeil());
    b.appendChild(pf);
    return b;
  }

  /* ---- Bereich zeichnen ---- */
  function zeichne(slot, cart) {
    slot.classList.remove("vfwk-warten");
    var art = slot.getAttribute("data-art") === "korb" ? "korb" : "seite";
    var e = L.empfehlungen(art, pools.gerichte, pools.extras, cart, pools.handles, poolOpt());
    slot.textContent = "";
    if (!e.karten.length) { slot.hidden = true; return; }
    slot.hidden = false;
    var sec = el("section", "vfwk-empf vfwk-empf--" + art);
    sec.setAttribute("data-modus", e.modus);
    var kopf = el("div", "vfwk-empf__kopf");
    kopf.appendChild(el("h2", "vfwk-empf__h", art === "korb" ? "Könnte Dir auch schmecken" : "Hast Du etwas vergessen?"));
    sec.appendChild(kopf);
    var liste = el("div", "vfwk-empf__liste");
    e.karten.forEach(function (k) { liste.appendChild(k.typ === "extras" ? karteExtras() : karteGericht(k)); });
    sec.appendChild(liste);
    slot.appendChild(sec);
  }

  /* Der Bereich selbst kann leer und ausgeblendet sein; massgebend ist der Rahmen (.vfwk-oben) um ihn. */
  function sichtbar(n) { var r = n && (n.parentElement || n); return !!(r && (r.offsetWidth || r.offsetHeight || r.getClientRects().length)); }

  function alleSlots() { return Array.prototype.slice.call(doc.querySelectorAll("[data-vfwk-empf]")); }

  function aktualisiere() {
    var slots = alleSlots();
    if (!slots.length) return;
    if (laeuft) { nochmal = true; return; } /* es läuft schon ein Abruf: danach noch einmal, damit keine Änderung verloren geht */
    var zeigbar = slots.filter(sichtbar);
    if (!zeigbar.length && !popup) return; /* Mini-Warenkorb zu: nichts laden */
    laeuft = true;
    var nr = ++stand;
    Promise.all([korbHolen(), ladePools()])
      .then(function (r) { return tagsHolen(r[0]).then(function () { return mitErsatz(r[0]); }).then(function () { return r; }); })
      .then(function (r) {
        if (nr !== stand) return; /* überholt: ein neuerer Stand ist unterwegs */
        cartLetzter = r[0];
        if (!r[1]) { slots.forEach(function (s) { s.classList.remove("vfwk-warten"); s.hidden = true; }); return; }
        zeigbar.forEach(function (s) { zeichne(s, cartLetzter); });
        if (popup && !popup.hidden) popupFuellen();
      })
      .catch(function () {
        /* ohne cart.js: keine leere Fläche stehen lassen */
        slots.forEach(function (s) { s.classList.remove("vfwk-warten"); if (!s.firstChild) s.hidden = true; });
      })
      .then(function () { laeuft = false; if (nochmal || nr !== stand) { nochmal = false; planen(); } });
  }

  function planen() {
    if (planTimer || leerBekannt) return;
    planTimer = root.setTimeout(function () { planTimer = null; aktualisiere(); }, 250);
  }
  function geaendert() { leerBekannt = false; planen(); } /* der Warenkorb hat sich (vielleicht) geändert */

  /* ---- Warenkorb ändern ---- */
  function post(url, body) {
    return root.fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body || {}) })
      .then(function (r) { if (!r.ok) throw new Error("cart " + r.status); return r; });
  }

  /* Nach einer eigenen Änderung: window.refreshCart() zeichnet Mini-Warenkorb bzw. Seite neu und meldet «cart-updated»
     (assets/component-cart.js). Fehlt es, melden wir selbst auf <cart-form>, damit Kühltasche, Rabatt-Balken und Liefertermin nachsehen. */
  function meldeAenderung() {
    var ziel = doc.getElementById("AjaxCartForm");
    if (ziel) {
      if (typeof root.refreshCart === "function") root.refreshCart();
      else { try { ziel.dispatchEvent(new root.Event("cart-updated")); } catch (e) { /* alter Browser */ } }
    }
    planen();
  }

  /* Eine feste Live-Region für Screenreader (einmal angelegt, dann nur der Text; so sagen alle Screenreader an):
     «… hinzugefügt» nach «+» in den Empfehlungen und im Extras-Fenster, sonst bleibt der Erfolg unhörbar. */
  var status = null;
  function statusAnlegen() {
    if (status || !alleSlots().length) return;
    status = el("p", "visually-hidden");
    status.setAttribute("role", "status");
    status.setAttribute("data-vfwk-status", "");
    doc.body.appendChild(status);
  }
  function ansagen(text) {
    if (!status) return;
    status.textContent = ""; /* gleicher Text zweimal (zweites «+»): erst leeren, sonst bleibt die zweite Ansage aus */
    root.setTimeout(function () { status.textContent = text; }, 50);
  }

  function hinzufuegen(knopf) {
    if (knopf.disabled) return; /* Sperre je Knopf: andere Karten bleiben bedienbar */
    var id = parseInt(knopf.getAttribute("data-vfwk-add"), 10);
    if (!id) return;
    var name = knopf.getAttribute("data-vfwk-name") || "Artikel";
    knopf.classList.remove("vfwk-fehler");
    knopf.classList.add("vfwk-laedt");
    knopf.disabled = true;
    post("/cart/add.js", { items: [{ id: id, quantity: 1 }] })
      .then(function () { ansagen(name + " hinzugefügt"); meldeAenderung(); })
      .catch(function () { knopf.classList.add("vfwk-fehler"); knopf.disabled = false; ansagen(name + " konnte nicht hinzugefügt werden"); })
      .then(function () { knopf.classList.remove("vfwk-laedt"); });
  }

  /* ---- Extras-Fenster ---- */
  function popupBauen() {
    var p = el("div", "vfwk-pop");
    p.hidden = true;
    p.setAttribute("role", "dialog"); p.setAttribute("aria-modal", "true"); p.setAttribute("aria-label", "Extras");
    var bg = el("div", "vfwk-pop__bg"); bg.setAttribute("data-vfwk-popup-zu", "");
    var box = el("div", "vfwk-pop__box");
    box.appendChild(el("div", "vfwk-pop__griff"));
    var kopf = el("div", "vfwk-pop__kopf");
    var t = el("div");
    t.appendChild(el("h3", "vfwk-pop__h", "Extras"));
    t.appendChild(el("p", "vfwk-pop__sub", "Shots, Noshballs und Saucen"));
    kopf.appendChild(t);
    var z = el("button", "vfwk-pop__zu"); z.type = "button"; z.setAttribute("aria-label", "Schliessen"); z.setAttribute("data-vfwk-popup-zu", "");
    z.appendChild(svgKreuz());
    kopf.appendChild(z);
    box.appendChild(kopf);
    box.appendChild(el("ul", "vfwk-pop__liste"));
    p.appendChild(bg); p.appendChild(box);
    doc.body.appendChild(p);
    return p;
  }

  function popupFuellen() {
    if (!popup || !pools) return;
    var imKorb = {};
    ((cartLetzter && cartLetzter.items) || []).forEach(function (i) { imKorb[i.handle] = i.quantity; });
    var ul = popup.querySelector(".vfwk-pop__liste");
    ul.textContent = "";
    L.extraVorschlaege(pools.extras, cartLetzter, 50).forEach(function (k) {
      var li = el("li", "vfwk-pop__zeile");
      li.appendChild(bildKnoten(k.bild, "vfwk-pop__bild", 104));
      li.appendChild(el("p", "vfwk-pop__name", k.title));
      var gr = el("p", "vfwk-pop__gr", k.groesse || "");
      if (imKorb[k.handle]) { gr.appendChild(doc.createTextNode(" · ")); gr.appendChild(el("b", null, imKorb[k.handle] + " im Warenkorb")); }
      li.appendChild(gr);
      var r = el("div", "vfwk-pop__rechts");
      r.appendChild(el("span", "vfwk-pop__preis", L.geldText(k.preis)));
      r.appendChild(plusKnopf(k));
      li.appendChild(r);
      ul.appendChild(li);
    });
  }

  function popupOeffnen(von) {
    popupFokus = von || null;
    if (!popup) popup = popupBauen();
    popup.hidden = false;
    doc.documentElement.classList.add("vfwk-pop-offen");
    ladePools().then(function () { popupFuellen(); planen(); });
    popupFuellen();
    var zu = popup.querySelector(".vfwk-pop__zu");
    if (zu) { zu.focus(); root.setTimeout(function () { if (popup && !popup.hidden && zu) zu.focus(); }, 0); } /* nach dem Klaviyo-Popup und anderen Fokus-Räubern */
  }
  function popupSchliessen() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    doc.documentElement.classList.remove("vfwk-pop-offen");
    if (popupFokus && popupFokus.focus && doc.contains(popupFokus)) popupFokus.focus();
    popupFokus = null;
  }

  /* ---- Warenkorb leeren ---- */
  var leerenTimer = null, leerenReset = null, leerenZustand = null, leerenBox = null;
  function leerenStop() {
    root.clearInterval(leerenTimer); root.clearTimeout(leerenReset);
    leerenTimer = null; leerenReset = null; leerenZustand = null;
  }
  function leerenLink(c) {
    c.textContent = "";
    c.removeAttribute("aria-live");
    var b = el("button", "vfwk-leeren__link", "Warenkorb leeren");
    b.type = "button"; b.setAttribute("data-vfwk-leeren-start", "");
    c.appendChild(b);
  }
  function leerenStart(c) {
    leerenStop();
    leerenBox = c;
    leerenZustand = L.leerenSchritt(null, "start");
    c.textContent = "";
    var box = el("span", "vfwk-leeren__box");
    var ja = el("button", "vfwk-leeren__ja");
    ja.type = "button"; ja.disabled = true; ja.setAttribute("aria-disabled", "true"); ja.setAttribute("data-vfwk-leeren-ja", "");
    ja.style.setProperty("--vfwk-sperre", L.SPERRE_S + "s");
    ja.appendChild(doc.createTextNode("Wirklich leeren?"));
    var zahl = el("span", "vfwk-leeren__zahl", " · " + leerenZustand.rest + " s");
    ja.appendChild(zahl);
    var nein = el("button", "vfwk-leeren__nein", "Abbrechen");
    nein.type = "button"; nein.setAttribute("data-vfwk-leeren-nein", "");
    box.appendChild(ja); box.appendChild(nein);
    c.appendChild(box);
    c.setAttribute("aria-live", "polite"); /* Screenreader: «Wirklich leeren? · 3 s» wird angesagt, bis der Knopf aktiv ist */
    nein.focus(); /* der ersetzte Knopf hatte den Fokus; sicherste Wahl ist «Abbrechen» */
    leerenTimer = root.setInterval(function () {
      if (!c.isConnected) { leerenStop(); return; } /* Warenkorb wurde neu geladen */
      leerenZustand = L.leerenSchritt(leerenZustand, "tick");
      if (leerenZustand.phase === "sperre") { zahl.textContent = " · " + leerenZustand.rest + " s"; return; }
      root.clearInterval(leerenTimer); leerenTimer = null;
      ja.disabled = false; ja.removeAttribute("aria-disabled");
      if (zahl.parentNode) zahl.parentNode.removeChild(zahl);
      leerenReset = root.setTimeout(function () { leerenStop(); if (c.isConnected) leerenLink(c); }, L.ZURUECK_S * 1000);
    }, 1000);
  }
  function leerenAusfuehren(c) {
    if (!L.leerenDarfLoeschen(leerenZustand)) return; /* noch gesperrt */
    var ja = c.querySelector("[data-vfwk-leeren-ja]");
    if (ja) ja.disabled = true;
    leerenStop();
    post("/cart/clear.js").then(function () {
      /* Warenkorbseite: Kasten rechts, Balken und Zähler stimmen nur nach einem frischen Laden (leerer Warenkorb ist ein anderer Aufbau) */
      if (doc.querySelector(".cart-section")) { root.location.reload(); return; }
      meldeAenderung();
    })
      .catch(function () {
        c.textContent = "";
        c.appendChild(el("span", "vfwk-leeren__fehler", "Das hat nicht geklappt. Bitte versuche es nochmals."));
        root.setTimeout(function () { if (c.isConnected) leerenLink(c); }, 3000);
      });
  }

  /* ---- Termin-Karte («Noch kein Liefertermin» / gewähltes Datum) im Kasten «Deine Bestellung» ----
     Liest das Datum aus dem Liefertermin-Block (window.VFWKDatum.lese(), assets/vf-liefertermin.js) und zeigt nur an.
     Fasst den Zur-Kasse-Knopf nicht an. Ohne Block (Skript fehlt) bleibt die Karte weg. */
  function terminMalen() {
    var karte = doc.querySelector("[data-vfwk-termin]");
    if (!karte) return;
    var d = root.VFWKDatum;
    /* nur Ware ohne Versand (nur Geschenkkarte): kein Liefertermin nötig, keine Karte. Quellen: der Block (data-ohne-versand, führt
       assets/vf-liefertermin.js per /cart.js nach) und der Merker im Kasten (snippets/cart-subtotal.liquid, kommt mit jedem Neuzeichnen) */
    var ohneVersand = !!doc.querySelector('[data-vflt][data-ohne-versand="true"], .cart-section .vfwk-ohne-versand');
    karte.hidden = !d || !doc.querySelector(".cart-section [data-js-cart-item]") || ohneVersand;
    if (karte.hidden) return;
    setzeTermin(karte, L.wochentagDatum(d.lese())); /* «Montag, 19.10.2026» oder "" ohne gültiges Datum */
  }
  function setzeTermin(karte, datum) {
    var ok = !!datum;
    /* nur schreiben, wenn sich etwas ändert (Ruhe für Screenreader und Beobachter) */
    karte.classList.toggle("vfwk-termin--ok", ok);
    var tt = karte.querySelector("[data-vfwk-termin-t]"), ts = karte.querySelector("[data-vfwk-termin-s]"), th = karte.querySelector("[data-vfwk-termin-h]");
    /* mit Datum: «Liefertermin», fett «Montag, 19.10.2026», klein der Hinweis (Wortlaut Pasci 15.10.2026) */
    var titel = ok ? "Liefertermin" : "Noch kein Liefertermin";
    var zeile = ok ? datum : "Wähle oben Deine Postleitzahl und den Liefertermin.";
    if (tt.textContent !== titel) tt.textContent = titel;
    if (ts.textContent !== zeile) ts.textContent = zeile;
    if (th && th.hidden === ok) th.hidden = !ok;
  }
  function terminStarten() {
    if (!doc.querySelector("[data-vfwk-termin]")) return;
    terminMalen();
    root.addEventListener("vf-liefertermin", terminMalen); /* der Block meldet jede Änderung */
    root.addEventListener("cart-updated", terminMalen, true);
    var block = doc.querySelector("[data-vflt]");
    if (block && root.MutationObserver) new root.MutationObserver(terminMalen).observe(block, { attributes: true, attributeFilter: ["data-ohne-versand"] }); /* Geschenkkarte ↔ Gericht live */
  }

  /* ---- Kasse-Balken (Handy und Tablet, nur Warenkorbseite) ----
     Fester Balken unten mit Artikelzahl, Gesamtbetrag und «Zur Kasse». Er ist nur eine zweite Tür zum vorhandenen Knopf #vf-zur-kasse
     (Klick darauf; die Datum-Pflicht prüft assets/vf-liefertermin.js beim Absenden wie sonst), keine eigene Datumsprüfung, keine
     wechselnde Beschriftung (Pasci 14.10.2026). */
  var bar = null, barInfo = null, barKnopf = null, barNotiz = null;
  /* Anweisung im Balken: wo der Balken steht (max-width wie in vf-warenkorb.css), aber nicht im Querformat mit wenig Höhe: dort bliebe mit
     offenem Feld zu wenig von der Seite sichtbar (Prüfung D3-N2), die Anweisung bleibt dann im Kasten */
  var BAR_MEDIA = "(max-width:1023px) and (min-height:501px)";
  function korbLeer() { return !doc.querySelector(".cart-section [data-js-cart-item]"); }
  function barZeichnen() {
    if (!bar) return;
    bar.hidden = korbLeer();
    /* angezeigte Zahl ohne Kühltasche (snippets/vf-korb-anzahl.liquid, Pasci 21.10.2026), älterer Stand: echte Zahl */
    var n = doc.querySelector("[data-cart-count-anzeige]") || doc.querySelector("[data-cart-count]"), summe = doc.getElementById("cart_total");
    var zahl = n ? n.textContent.trim() : "", gesamt = summe && summe.textContent.trim() ? "Gesamt " + summe.textContent.trim() : "";
    /* nur die Kühltasche (angezeigt 0): keine «0 Artikel», nur der Betrag */
    var info = zahl === "0" ? gesamt : zahl + " Artikel" + (gesamt ? " · " + gesamt : "");
    if (barInfo.textContent !== info) barInfo.textContent = info;
  }
  function barBauen() {
    if (bar || !doc.querySelector(".cart-section") || !doc.getElementById("vf-zur-kasse")) return;
    bar = el("div", "vfwk-bar");
    bar.setAttribute("role", "region"); bar.setAttribute("aria-label", "Zur Kasse");
    barInfo = el("p", "vfwk-bar__info");
    barKnopf = el("button", "vfwk-bar__knopf", "Zur Kasse"); barKnopf.type = "button";
    barNotiz = el("div", "vfwk-bar__notiz"); /* Platz für «Kommentar zur Bestellung» am Handy (notizPlatzieren) */
    bar.appendChild(barInfo); bar.appendChild(barNotiz); bar.appendChild(barKnopf);
    doc.body.appendChild(bar);
    doc.documentElement.classList.add("vfwk-bar-an");
    barKnopf.addEventListener("click", function () { var kasse = doc.getElementById("vf-zur-kasse"); if (kasse) kasse.click(); });
    barZeichnen();
    /* Die Seite bekommt unten so viel Platz, wie der Balken hoch ist (er wächst mit offener Anweisung) */
    if (typeof root.ResizeObserver === "function") new root.ResizeObserver(function () { doc.documentElement.style.setProperty("--vfwk-bar-h", bar.offsetHeight + "px"); }).observe(bar);
    root.addEventListener("cart-updated", barZeichnen, true);
    var sec = doc.querySelector(".cart-section");
    if (sec && root.MutationObserver) new root.MutationObserver(barZeichnen).observe(sec, { childList: true, subtree: true, characterData: true });
  }

  /* ---- Anweisung zur Bestellung (snippets/vf-warenkorb-notiz.liquid) ----
     Knopf öffnet und schliesst das Feld; das Feld wächst mit. Auf der Warenkorbseite ersetzt das Theme nach jeder Ajax-Änderung den
     Kasten (#AjaxCartSubtotal) mit cart.note vom Server, die getippte Notiz ist aber erst mit «Zur Kasse» dort: darum merken wir sie
     (wie das Theme unter demselben Schlüssel in sessionStorage, assets/component-order-instructions.js) und setzen sie wieder ein,
     ebenso den Zustand offen/zu, den Du gewählt hast. */
  var NOTIZ_SCHLUESSEL = "cartSpecialInstructions";
  var NOTIZ_MAX_PX = 160; /* wie max-height in vf-warenkorb.css */
  var notizText = null, notizOffen = null; /* null: noch nichts getippt bzw. gewählt */
  function notizGespeichert() { try { return root.sessionStorage.getItem(NOTIZ_SCHLUESSEL); } catch (e) { return null; } }
  function notizMerken(text) { notizText = text; try { root.sessionStorage.setItem(NOTIZ_SCHLUESSEL, text); } catch (e) { /* privat: nur im Speicher */ } }
  function notizWachsen(feld) {
    feld.style.height = "";
    if (!feld.getClientRects().length) return; /* Mini-Warenkorb zu: dann gilt rows="2", gemessen wird beim Tippen */
    feld.style.height = "auto";
    var rand = feld.offsetHeight - feld.clientHeight;
    feld.style.height = Math.min(feld.scrollHeight + rand, NOTIZ_MAX_PX) + "px";
  }
  function notizZustand(box, offen) {
    var auf = box.querySelector("[data-vfwk-notiz-auf]"), wrap = box.querySelector("[data-vfwk-notiz-feld]"), feld = box.querySelector("textarea");
    if (!auf || !wrap || !feld) return;
    wrap.hidden = !offen;
    auf.setAttribute("aria-expanded", offen ? "true" : "false");
    var text = auf.querySelector("[data-vfwk-notiz-text]");
    var soll = offen || feld.value.trim() ? "Kommentar zur Bestellung" : "Kommentar zur Bestellung hinzufügen";
    if (text && text.textContent !== soll) text.textContent = soll;
    if (offen) notizWachsen(feld);
  }
  /* Am Handy steht die Anweisung im Kasse-Balken über «Zur Kasse» (Pasci 15.10.2026: am Seitenende sieht sie kaum jemand), am Computer im
     Kasten. Es gibt immer nur EIN Feld (name="note" geht sonst doppelt an die Bestellung): Es wird verschoben, nie kopiert. Zeichnet das Theme
     den Kasten neu, kommt dort ein neues Feld dazu; das bisherige (mit Text, Zustand und Fokus) bleibt, das neue wird entfernt. */
  var notizBox = null, notizMedia = null;
  function notizPlatzieren() {
    var boxen = Array.prototype.slice.call(doc.querySelectorAll(".cart-section [data-vfwk-notiz], .vfwk-bar [data-vfwk-notiz]"));
    if (!boxen.length) return;
    if (!notizBox || !notizBox.isConnected) notizBox = boxen[0];
    boxen.forEach(function (b) { if (b !== notizBox && b.parentNode) b.parentNode.removeChild(b); });
    var kastenPlatz = doc.querySelector(".cart-section .cart__instructions");
    var ziel = barNotiz && notizMedia && notizMedia.matches ? barNotiz : kastenPlatz;
    if (!ziel || notizBox.parentNode === ziel) return;
    var feld = notizBox.querySelector("textarea"), fokus = feld && doc.activeElement === feld;
    var a = fokus ? feld.selectionStart : 0, e = fokus ? feld.selectionEnd : 0;
    ziel.appendChild(notizBox);
    if (fokus) { feld.focus(); try { feld.setSelectionRange(a, e); } catch (x) { /* alter Browser */ } }
  }
  function notizMalen() {
    notizPlatzieren();
    var gespeichert = notizText !== null ? notizText : notizGespeichert();
    Array.prototype.forEach.call(doc.querySelectorAll("[data-vfwk-notiz]"), function (box) {
      var feld = box.querySelector("textarea");
      if (!feld) return;
      /* getippt gilt immer (auch leer); beim Laden nur eine gespeicherte Notiz mit Inhalt, wie das Theme */
      if ((notizText !== null || gespeichert) && feld.value !== gespeichert) feld.value = gespeichert;
      notizZustand(box, notizOffen !== null ? notizOffen : !!feld.value.trim());
    });
  }
  function notizStarten() {
    if (!doc.querySelector("[data-vfwk-notiz]")) return;
    if (barNotiz && root.matchMedia) {
      notizMedia = root.matchMedia(BAR_MEDIA);
      if (notizMedia.addEventListener) notizMedia.addEventListener("change", notizMalen); else if (notizMedia.addListener) notizMedia.addListener(notizMalen);
    }
    notizMalen();
    doc.addEventListener("input", function (ev) {
      var feld = ev.target, box = feld && feld.closest ? feld.closest("[data-vfwk-notiz]") : null;
      if (!box || feld.tagName !== "TEXTAREA") return;
      notizMerken(feld.value);
      notizWachsen(feld);
      if (feld.scrollIntoView && feld.closest(".sidebar__body")) feld.scrollIntoView({ block: "nearest" }); /* gewachsenes Feld nicht unter dem Fuss des Mini-Warenkorbs */
    });
    doc.addEventListener("focusin", function (ev) {
      var feld = ev.target;
      if (feld && feld.tagName === "TEXTAREA" && feld.closest("[data-vfwk-notiz]")) notizWachsen(feld); /* lange Notiz, Mini-Warenkorb war beim Laden zu */
    });
    var kasten = doc.querySelector(".cart-section .vfwk-summen");
    /* Theme hat den Kasten neu gezeichnet (refreshCart, auch nach unserem cart-updated): Notiz und Termin-Karte wieder einsetzen */
    if (kasten && root.MutationObserver) new root.MutationObserver(function () { notizMalen(); terminMalen(); }).observe(kasten, { childList: true });
  }
  function notizUmschalten(knopf) {
    var box = knopf.closest("[data-vfwk-notiz]");
    if (!box) return;
    notizOffen = knopf.getAttribute("aria-expanded") !== "true";
    notizZustand(box, notizOffen);
    if (notizOffen) { var feld = box.querySelector("textarea"); if (feld) feld.focus(); }
  }

  /* ---- Direkt zur Kasse (Mini-Warenkorb, nur Ware ohne Versand; nach PR #22) ----
     Ohne Skript führt der Link zu /checkout. Mit Skript prüft der Klick den AKTUELLEN Warenkorb (/cart.js): Ein veralteter Mini-Warenkorb (zweiter Tab,
     Zurück-Taste) darf nie mit einem Gericht ohne Liefertermin zur Kasse springen; ist der Stand nicht mehr «ohne Versand» oder scheitert die Prüfung,
     geht es zur Warenkorbseite (dort Liefertag oder Kasse). Eine getippte Anweisung geht vorher an den Warenkorb (der Link schickt kein Formular). */
  var DIREKT_MS = 3000;
  var BUSY_MS = 8000; /* so lange gilt ein Klick als unterwegs; kommt die Seite zurück (abgebrochen, Zurück-Taste), ist der Knopf wieder bedienbar */
  function direktFrei() { Array.prototype.forEach.call(doc.querySelectorAll("[data-vfwk-direkt-kasse][aria-busy]"), function (l) { l.removeAttribute("aria-busy"); }); }
  function mitZeitlimit(url, opt) {
    var ctrl = root.AbortController ? new root.AbortController() : null;
    var t = ctrl ? root.setTimeout(function () { ctrl.abort(); }, DIREKT_MS) : null;
    if (ctrl) opt.signal = ctrl.signal;
    return root.fetch(url, opt).then(function (r) { if (t) root.clearTimeout(t); return r; }, function (e) { if (t) root.clearTimeout(t); throw e; });
  }
  function direktKasse(ev, link) {
    if (ev.defaultPrevented || ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    ev.preventDefault();
    if (link.getAttribute("aria-busy") === "true") return; /* Doppelklick */
    link.setAttribute("aria-busy", "true");
    root.setTimeout(function () { link.removeAttribute("aria-busy"); }, BUSY_MS);
    var ziel = link.href;
    var notiz = Array.prototype.filter.call(doc.querySelectorAll('textarea[name="note"]'), function (n) { return n.value !== n.defaultValue; })[0];
    function zurSeite() { link.removeAttribute("aria-busy"); root.location.href = "/cart"; }
    mitZeitlimit("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("cart.js " + r.status); return r.json(); })
      .then(function (c) {
        if (!(c && c.item_count > 0 && c.requires_shipping === false)) { zurSeite(); return; }
        if (!notiz) { root.location.href = ziel; return; }
        return mitZeitlimit("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ note: notiz.value }) })
          .catch(function () { /* die Kasse geht vor */ })
          .then(function () { root.location.href = ziel; });
      })
      .catch(zurSeite);
  }

  /* Versand-Stand (nur Geschenkkarte ja/nein) nach Zurück-Taste (bfcache) oder Tab-Wechsel: stimmt der Merker im Kasten/Fuss
     (snippets/cart-subtotal.liquid) nicht mehr mit /cart.js, zeichnet das Theme Mini-Warenkorb und Kasten neu (Knopf, Termin-Karte). */
  var versandLaeuft = false;
  function versandAbgleich() {
    if (versandLaeuft || typeof root.refreshCart !== "function" || !doc.getElementById("AjaxCartSubtotal")) return;
    versandLaeuft = true;
    korbHolen()
      .then(function (c) {
        var ohne = !!(c && c.item_count > 0 && c.requires_shipping === false);
        if (ohne !== !!doc.querySelector(".vfwk-ohne-versand")) root.refreshCart();
      })
      .catch(function () { /* still: beim Klick prüft direktKasse ohnehin den aktuellen Stand */ })
      .then(function () { versandLaeuft = false; });
  }

  /* ---- Ereignisse (eine Delegation für alles) ---- */
  doc.addEventListener("click", function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t) return;
    var add = t.closest("[data-vfwk-add]");
    if (add) { ev.preventDefault(); hinzufuegen(add); return; }
    var pop = t.closest("[data-vfwk-popup]");
    if (pop) { ev.preventDefault(); popupOeffnen(pop); return; }
    if (t.closest("[data-vfwk-popup-zu]")) { ev.preventDefault(); popupSchliessen(); return; }
    var direkt = t.closest("[data-vfwk-direkt-kasse]");
    if (direkt) { direktKasse(ev, direkt); return; }
    var notiz = t.closest("[data-vfwk-notiz-auf]");
    if (notiz) { ev.preventDefault(); notizUmschalten(notiz); return; }
    var start = t.closest("[data-vfwk-leeren-start]");
    if (start) { ev.preventDefault(); leerenStart(start.closest("[data-vfwk-leeren]")); return; }
    var ja = t.closest("[data-vfwk-leeren-ja]");
    if (ja) { ev.preventDefault(); leerenAusfuehren(ja.closest("[data-vfwk-leeren]")); return; }
    if (t.closest("[data-vfwk-leeren-nein]")) {
      ev.preventDefault();
      var c = leerenBox && leerenBox.isConnected ? leerenBox : t.closest("[data-vfwk-leeren]");
      leerenStop(); if (c) { leerenLink(c); var l = c.querySelector("button"); if (l) l.focus(); }
    }
  });
  doc.addEventListener("keydown", function (ev) {
    if (ev.key === "Escape") popupSchliessen();
    if (ev.key !== "Tab" || !popup || popup.hidden) return;
    /* Fokusfalle: Tab bleibt im Extras-Fenster */
    var f = Array.prototype.filter.call(popup.querySelectorAll("button,a[href],input,select,textarea,[tabindex]"), function (e) { return !e.disabled && e.tabIndex >= 0 && e.getClientRects().length; });
    if (!f.length) return;
    var erst = f[0], letzt = f[f.length - 1], aktiv = doc.activeElement;
    if (!popup.contains(aktiv)) { ev.preventDefault(); erst.focus(); }
    else if (ev.shiftKey && aktiv === erst) { ev.preventDefault(); letzt.focus(); }
    else if (!ev.shiftKey && aktiv === letzt) { ev.preventDefault(); erst.focus(); }
  });

  function start() {
    var slots = alleSlots();
    if (slots.length && typeof root.IntersectionObserver === "function") {
      var io = new root.IntersectionObserver(function (eintraege) {
        if (eintraege.some(function (e) { return e.isIntersecting; })) planen();
      });
      slots.forEach(function (s) { io.observe(s.parentElement || s); });
    }
    planen();
    statusAnlegen();
    barBauen();
    terminStarten();
    notizStarten();
    /* Das Theme meldet Warenkorb-Änderungen mit «cart-updated» (ohne bubbles) und zählt im Kopf mit */
    root.addEventListener("cart-updated", geaendert, true);
    var zaehler = doc.querySelector("[data-header-cart-count]");
    if (zaehler && root.MutationObserver) new root.MutationObserver(geaendert).observe(zaehler, { childList: true, characterData: true, subtree: true });
    root.addEventListener("pageshow", function (e) { if (e.persisted) { direktFrei(); geaendert(); versandAbgleich(); } });
    doc.addEventListener("visibilitychange", function () { if (!doc.hidden) { geaendert(); versandAbgleich(); } });
  }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", start); else start();
})(typeof window !== "undefined" ? window : globalThis);
